import React from 'react';
import { ItemRowCell, useLayout } from '@ukpostbox/frontend-framework';
import { MailItemThumbnailsType, MailPartTypeEnum } from './Types/ThumbnailTypes';
import { MapMailItemThumbnails } from './MapMailItemThumbnails';

function MailItemThumbnails(props: MailItemThumbnailsType) {
	const { isTiny, isSmall } = useLayout();

	return (
		<>
			<ItemRowCell extraClass='mail-item-thumbs'>
				<MapMailItemThumbnails
					mailType={MailPartTypeEnum['Mail-Envelopes']}
					files={props.files}
					onClickCallback={props.onClickCallback}
					size={props.size}
				/>
			</ItemRowCell>

			<ItemRowCell extraClass='mail-item-thumbs'>
				<MapMailItemThumbnails
					mailType={MailPartTypeEnum['Mail-Contents']}
					files={props.files}
					onClickCallback={props.onClickCallback}
					hideMissing={isTiny || isSmall}
					size={props.size}
				/>
			</ItemRowCell>
		</>
	);
}

export { MailItemThumbnails };
